import { toDisplayString as _toDisplayString, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-2e43e5c6")

_pushScopeId("data-v-2e43e5c6")
const _hoisted_1 = { class: "order-customers-price-block" }
const _hoisted_2 = { class: "customers-price-item" }
const _hoisted_3 = { class: "customers-price-item" }
const _hoisted_4 = { class: "customers-price-item" }
const _hoisted_5 = {
  key: 0,
  class: "customers-price-item"
}
const _hoisted_6 = { class: "after-colon" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("span", null, _toDisplayString(_ctx.$t('cashier.label.total')), 1),
      _createVNode("span", null, _toDisplayString(_ctx.formatAmount(_ctx.priceTotalWithOutDiscount)) + _toDisplayString(_ctx.currencySign), 1)
    ]),
    _createVNode("div", _hoisted_3, [
      _createVNode("span", null, _toDisplayString(_ctx.$t('label.discount')), 1),
      _createVNode("span", null, _toDisplayString(_ctx.formatAmount(_ctx.discountTotal)) + _toDisplayString(_ctx.currencySign), 1)
    ]),
    _createVNode("div", _hoisted_4, [
      _createVNode("span", null, _toDisplayString(_ctx.$t('newOrder.total-pay')), 1),
      _createVNode("span", null, _toDisplayString(_ctx.formatAmount(_ctx.customerTotalToPay)) + _toDisplayString(_ctx.currencySign), 1)
    ]),
    (_ctx.businessClientTotalToPay)
      ? (_openBlock(), _createBlock("div", _hoisted_5, [
          _createVNode("span", _hoisted_6, _toDisplayString(_ctx.$t('label.business-client-total')), 1),
          _createVNode("span", null, _toDisplayString(_ctx.formatAmount(_ctx.businessClientTotalToPay)) + _toDisplayString(_ctx.currencySign), 1)
        ]))
      : _createCommentVNode("", true)
  ]))
})